import { render, staticRenderFns } from "./ViewSetting.vue?vue&type=template&id=49c50831"
import script from "./ViewSetting.vue?vue&type=script&lang=ts"
export * from "./ViewSetting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports